// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a6c8e776","488":"81785c45"}[chunkId] + ".chunk.js";
};